import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { MediaPreview } from "@/components/site/FileUploader";
import { WhatsAppIcon } from "@/components/site/WhatsAppFloat";
import { api, errMsg, fmtDateTime, fmtDay } from "@/lib/api";
import { DR_STATUS, waLink } from "@/lib/content";

const phoneWa = (t) => { const d = (t || "").replace(/\D/g, ""); return d.startsWith("55") ? d : `55${d}`; };

const DrCard = ({ d, onStatus }) => (
  <div className="card-tech p-6" data-testid={`admin-dr-${d.protocolo}`}>
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <p className="font-mono font-bold text-red-400">{d.protocolo}</p>
        <p className="font-heading text-lg font-bold uppercase text-white">{d.nome}</p>
        <p className="text-xs text-slate-500">{d.telefone} · {d.email || "—"} · {d.cidade}{d.estado ? `/${d.estado}` : ""} · {fmtDateTime(d.created_at)}</p>
      </div>
      <select className="field !w-auto" value={d.status} onChange={(e) => onStatus(d.id, e.target.value)} data-testid={`admin-dr-status-${d.protocolo}`}>
        {Object.entries(DR_STATUS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
      </select>
    </div>
    <div className="mt-4 grid gap-2 text-sm text-slate-300 md:grid-cols-2">
      <p><b className="text-white">Veículo:</b> {d.veiculo}</p>
      <p><b className="text-white">Inspeção:</b> {fmtDay(d.data_inspecao)} {d.periodo} — {d.local_inspecao || "a combinar"}</p>
      <p className="md:col-span-2"><b className="text-white">Ruído:</b> {d.descricao}</p>
      <p><b className="text-white">Quando:</b> {d.quando_ocorre || "—"}</p>
      <p><b className="text-white">Velocidade:</b> {d.velocidade || "—"}</p>
      <p><b className="text-white">Piso:</b> {d.piso || "—"}</p>
      <p><b className="text-white">Condições:</b> {d.condicoes || "—"}</p>
      {d.pre_diagnostico?.problemas_relacionados?.length > 0 && <p className="md:col-span-2"><b className="text-white">Problemas:</b> {d.pre_diagnostico.problemas_relacionados.join("; ")}</p>}
    </div>
    {d.arquivos_meta?.length > 0 && (
      <div className="mt-4 grid grid-cols-2 gap-2 md:grid-cols-4">
        {d.arquivos_meta.map((f) => <div key={f.id} className="flex h-32 items-center justify-center overflow-hidden border border-slate-700 bg-black/40"><MediaPreview f={f} /></div>)}
      </div>
    )}
    <a href={waLink(`Olá, ${d.nome}! Aqui é o Nillo, da Nillo Ruídos, sobre a sua solicitação ${d.protocolo}.`, phoneWa(d.telefone))} target="_blank" rel="noreferrer" className="btn-line mt-5 !py-2" data-testid={`admin-dr-wa-${d.protocolo}`}>
      <WhatsAppIcon className="h-4 w-4" /> Responder cliente
    </a>
  </div>
);

export const AdminDrList = () => {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/admin/dr-ruidos").then((r) => setList(r.data)); }, []);
  const onStatus = async (id, status) => {
    try {
      await api.put(`/admin/dr-ruidos/${id}`, { status });
      setList((l) => l.map((x) => (x.id === id ? { ...x, status } : x)));
      toast.success("Status atualizado");
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!list) return <Loader2 className="mx-auto h-6 w-6 animate-spin text-red-500" />;
  if (!list.length) return <p className="card-tech py-10 text-center text-sm text-slate-500" data-testid="admin-dr-empty">Nenhuma solicitação do Dr. Ruídos.</p>;
  return <div className="space-y-4" data-testid="admin-dr-list">{list.map((d) => <DrCard key={d.id} d={d} onStatus={onStatus} />)}</div>;
};
